import {
    BadgeCompletion,
    BadgeDescription,
    BadgeRow,
    BadgeTitle,
    CloseButton,
    Container,
    PreviewTop,
    Wrapper
} from './PreviewScreen.styled';
import {DisableScroll, EnableScroll} from '@utils/scrollController';
import CrossIcon from '@assets/svg/match/missing.svg';
import {useEffect, useRef, useState} from 'react';
import Badge from '../Badge';
import { useI18n } from '@i18n/useI18n';
import Modal from '@components/Buttons/Modal';

interface IBadge {
    title:string,
    badge:any,
    stage:number
    description:string,
}

interface IProps {
    screenTitle:string,
    badge?:any,
    closeScreen?: (closeScreen:boolean) => void,
    inside?:boolean,
}

const PreviewScreen = (props:IProps) => {
    const [start, setStart] = useState(false);
    const i18n = useI18n();
    const ref = useRef(null)

    useEffect(() => {
        DisableScroll()
        setStart(true)
        return () => {
            EnableScroll()
        }
    }, [])

    const OnCloseScreen = () => {
        setStart(false)
        setTimeout(() => {
            props.closeScreen(false)
        }, 700);
    }

    return (
        <Modal ref={ref} onClose={props.closeScreen} animateMiddel={true}>
            <Wrapper onClick={() => OnCloseScreen()} start={start} background={"/images/badges/badgeBG.jpg"}>
                <Container>
                    <PreviewTop>
                        <span>{props.screenTitle === "rewarditempreview"?"Reward " + i18n.t("information"): "Attender Badge " + i18n.t("information")}</span>
                        <CloseButton onClick={() => OnCloseScreen()}>
                            <CrossIcon />
                        </CloseButton>
                    </PreviewTop>
                    <BadgeRow>
                        <BadgeTitle>
                            {i18n.t(props?.badge?.title)}
                        </BadgeTitle>
                        <BadgeDescription>
                            {i18n.t(props?.badge?.description)}
                        </BadgeDescription>
                    </BadgeRow>
                    <BadgeRow paddingTop={props.screenTitle === "rewarditempreview"?20:0}>
                        <Badge badge={props.badge} reward={true} preview={props.screenTitle === "rewarditempreview"?false:true} enabled={true} stage={0} />
                    </BadgeRow>
                    <BadgeRow>
                        {props?.badge?.levels >= 2 &&
                            <BadgeCompletion>
                                {props.badge.progress}% {i18n.t("completed")}
                            </BadgeCompletion>
                        }
                    </BadgeRow>
                </Container>
            </Wrapper>
        </Modal>
    );
}

export default PreviewScreen;